import React from 'react';
import { HrButtons, HrFlexContainer } from '@components/styles/hr-styles';

const STYLES = { fontSize: '16px', margin: '0' };

export const ACTIONS_COLUMN = (
  navigate,
  setActualRowId,
  setShowModalApproveRequest,
  setShowModalRejectRequest,
  setShowModalModifyRequest,
  setShowModalDeleteRequest,
  onShowToast,
  t
) => {
  return {
    id: 'Actions',
    Header: 'ACCIONES',
    Cell: ({ row }) => (
      <HrFlexContainer flexWrap='noWrap' gap='4px' justifyContent='flex-end'>
        {row?.original?.templateId && (
          row.original.isTemplateDeleted ? (
            <span
              title={t('requestVacancies.colaborativeSelection.modal.linkedTemplate.deletedTooltip')}
              style={{ display: 'inline-flex', cursor: 'not-allowed' }}
            >
              <HrButtons
                size='small'
                category='tertiaryGray'
                padding='8px'
                width='32px'
                disabled
                style={{ pointerEvents: 'none', opacity: 0.5 }}
              >
                <i className='hr-Layers' style={STYLES} />
              </HrButtons>
            </span>
          ) : (
            <HrButtons
              title={t('requestVacancies.colaborativeSelection.modal.linkedTemplate.title')}
              size='small'
              category='tertiaryGray'
              padding='8px'
              width='32px'
              onClick={() => {
                window.open(`/app/vacancy_request/template/${row.original.templateId}`, '_blank');
              }}
            >
              <i className='hr-Layers' style={STYLES} />
            </HrButtons>
          )
        )}

        <HrButtons
          title={t('requestVacancies.colaborativeSelection.modal.seeRequest.title')}
          size='small'
          category='tertiaryGray'
          padding='8px'
          width='32px'
          onClick={() => navigate(`/app/vacancy_request/form_request/${row.values._id}/view`)}
        >
          <i className='hr-Eye-open' style={STYLES} />
        </HrButtons>
        {row.values.status === 0 && (
          <HrButtons
            title={t('requestVacancies.colaborativeSelection.modal.approveRequest.title')}
            size='small'
            category='tertiaryGray'
            padding='8px'
            width='32px'
            onClick={() => {
              setActualRowId(row.values._id);
              setShowModalApproveRequest(true);
            }}
          >
            <i className='hr-Checkmark' style={STYLES} />
          </HrButtons>
        )}
        {(row.values.status === 0 || row.values.status === 3) && (
          <HrButtons
            title={t('requestVacancies.colaborativeSelection.modal.modifyRequest.title')}
            size='small'
            category='tertiaryGray'
            padding='8px'
            width='32px'
            onClick={() => {
              setActualRowId(row.values._id);
              setShowModalModifyRequest(true);
            }}
          >
            <i className='hr-Pencil' style={STYLES} />
          </HrButtons>
        )}
        {(row.values.status === 0 || row.values.status === 3) && (
          <HrButtons
            title={t('requestVacancies.colaborativeSelection.modal.rejectRequest.title')}
            size='small'
            category='tertiaryGray'
            padding='8px'
            width='32px'
            onClick={() => {
              setActualRowId(row.values._id);
              setShowModalRejectRequest(true);
            }}
          >
            <i className='hr-Close' style={STYLES} />
          </HrButtons>
        )}
        {row.values.status === 1 && (
          <HrButtons
            title={`Ir a la vacante ${row.original.isDraft ? 'borrador' : ''}`}
            size='small'
            category='tertiaryGray'
            padding='8px'
            width='32px'
            onClick={() => {
              if (row.original.isDeleted) {
                onShowToast({
                  visible: true,
                  type: 'error',
                  message: t(`crudVacancy.infoVacancyDeleted`)
                });
                return;
              }
              window.open(
                `/app/vacancy/${
                  row.original.isDraft ? `edit/${row.values.idVacancy}` : `getVacancy/${row.values.idVacancy}/20`
                }`,
                `_blank`
              );
            }}
          >
            <i className='hr-File' style={STYLES} />
          </HrButtons>
        )}
        <HrButtons
          title={t('requestVacancies.colaborativeSelection.modal.deleteRequest.title')}
          size='small'
          category='tertiaryGray'
          padding='8px'
          width='32px'
          onClick={() => {
            setActualRowId(row.values._id);
            setShowModalDeleteRequest(true);
          }}
        >
          <i className='hr-Trash' style={STYLES} />
        </HrButtons>
      </HrFlexContainer>
    )
  };
};
